import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../../../components/MaterialBox";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../../components/MaterialInput";
import { FormControl, FormHelperText, Icon } from "@mui/material";
import { useUserDetails } from "../../../../../../context/auth";
const BankDetails = ({
  employeeData,
  handleEmployeeDataChange,

  togglePage,
}) => {
  const { validationMessages } = useUserDetails();

  return (
    <MaterialBox>
      <MaterialTypography variant="h5">PF & ESI info</MaterialTypography>
      <Grid container spacing={1}>
        <Grid item width={320} md={4} sm={6} xs={12}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              UAN Number
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg. 123456789012"
            name="uannumber"
            value={employeeData.uannumber}
            onChange={handleEmployeeDataChange}
            error={employeeData.uannumberStatus === "error"}
            success={employeeData.uannumberStatus === "success"}
            disabled={togglePage.view}
            sx={{ minWidth: "250px" }}
          />
          {employeeData.uannumberStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                UAN Number should be exactly 12 digits.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.uannumber && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.uannumber}
            </label>
          )}
        </Grid>

        <Grid item width={320} md={4} sm={6} xs={12}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Member ID
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            name="memberid"
            placeholder="eg: A121"
            value={employeeData.memberid}
            onChange={handleEmployeeDataChange}
            error={employeeData.memberidStatus === "error"}
            success={employeeData.memberidStatus === "success"}
            disabled={togglePage.view}
            sx={{ minWidth: "250px" }}
          />
          {employeeData.memberidStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only text and numbers (max 25 characters).
              </FormHelperText>
            </FormControl>
          )}
        </Grid>

        <Grid item width={320} md={4} sm={6} xs={12}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              ESIC Number
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg. 12345678901234567"
            name="esicnumber"
            value={employeeData.esicnumber}
            onChange={handleEmployeeDataChange}
            error={employeeData.esicnumberStatus === "error"}
            success={employeeData.esicnumberStatus === "success"}
            disabled={togglePage.view}
            sx={{ minWidth: "250px" }}
          />
          {employeeData.esicnumberStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                ESI Number should contain only numbers (maximum 17 digits).
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
      </Grid>
    </MaterialBox>
  );
};

export default BankDetails;
